import WebFont from 'webfontloader';

function loadMenuFonts(layout) {
  const fonts = [layout.text.default_font, layout.text.title_font].filter(
    (font) => font != null
  );
  // var fonts = [layout.text.default_font, layout.text.title_font, 'quimby-gubernatorial'].filter(font => font != null);
  const requests = [
    loadGoogleFonts(fonts),
    ...fonts.map((font) => loadTypekitFont(font)),
    ...fonts.map((font) => loadFontComFont(font)),
  ];

  return Promise.all(requests);
}

function loadGoogleFonts(fonts) {
  return new Promise((resolve) => {
    WebFont.load({
      google: {
        families: fonts,
      },
      active: () => {
        console.log('loadGoogleFonts(true)');
        resolve(true);
      },
      inactive: () => {
        console.log('loadGoogleFonts(false)');
        resolve(false);
      },
      classes: false,
    });
  });
}

function loadTypekitFont() {
  return new Promise((resolve) => {
    // try {

    //     WebFont.load({
    //         typekit: {
    //             id: font,
    //         },
    //         active: () => { console.log('loadTypekitFont(true)'); resolve(true) },
    //         inactive: () => { console.log('loadTypekitFont(false)'); resolve(false) },
    //         fontactive: () => { console.log('loadTypekitFont(true)'); resolve(true) },
    //         fontinactive: () => { console.log('loadTypekitFont(false)'); resolve(false) },
    //         classes: false,
    //     });

    //     // console.log('loadTypekitFont(' + x + ')');

    // } catch (error) {
    //     console.log('loadTypekitFont(error)');
    // }

    resolve(false);
  });
}

function loadFontComFont() {
  return new Promise((resolve) => {
    // WebFont.load({
    //     monotype: {
    //         projectId: font,
    //         loadAllFonts: true,
    //     },
    //     active: () => { console.log('loadFontComFont(true)'); resolve(true) },
    //     inactive: () => { console.log('loadFontComFont(false)'); resolve(false) },
    //     classes: false,
    // })

    resolve(false);
  });
}

export { loadMenuFonts };
